(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(['exports', 'lodash/xorBy', '../util/convert'], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require('lodash/xorBy'), require('../util/convert'));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.xorBy, global.convert);
    global.xorBy = mod.exports;
  }
})(this, function (exports, _xorBy2, _convert) {
  'use strict';

  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = exports.xorBy = undefined;

  var _xorBy3 = _interopRequireDefault(_xorBy2);

  function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
      default: obj
    };
  }

  /**
   * This method is like {@link array.xor} except that it accepts <code>iteratee</code> to generate the criterion by which elements are compared.
   * @function
   * @memberof array
   * @param {Object} object The object to modify.
   * @param {Array|string} path The path of the property to set.
   * @param {...Array} arrays The arrays to inspect.
   * @param {Function} [iteratee={@link https://lodash.com/docs#identity|lodash.identity}] The iteratee invoked per element.
   * @return {Object} Returns the updated object.
   * @example xorBy({ nested: { prop: [{ x: 1 }, { x: 2 }] } }, 'nested.prop', [{ x: 2 }, { x: 3 }], 'x') // => { nested: { prop: [{ x: 1 }, { x: 3 }] } }
   * @see {@link https://lodash.com/docs#xorBy|lodash.xorBy} for more information.
   * @since 0.3.0
   */
  var xorBy = (0, _convert.convert)(_xorBy3.default);
  exports.xorBy = xorBy;
  exports.default = xorBy;
});